module.exports = __webpack_public_path__ + "static/et-book-roman-line-figures-10d6df6a575fb60ab98d2a7d3792642a.woff";